import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENTS]: {
		url: '/company/:companyId/land_documents/',
	},

	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT]: {
		url: '/company/:companyId/land_documents/:landDocumentId/',
	},

	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT_PREVIEW]: {
		url: '/company/:companyId/land_documents/:landDocumentId/preview/',
	},

	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT_POPUP]: {
		url: '/company/:companyId/land_documents/:landDocumentId/popup/',
	},


	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].CREATE_LAND_DOCUMENT]: {
		url: '/company/:companyId/land_documents/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].PUT_LAND_DOCUMENT]: {
		url: '/company/:companyId/land_documents/:landDocumentId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].PATCH_LAND_DOCUMENT]: {
		url: '/company/:companyId/land_documents/:landDocumentId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].DELETE_LAND_DOCUMENT]: {
		url: '/company/:companyId/land_documents/:landDocumentId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}